module.exports = __webpack_public_path__ + "img/imweb_design_1.b7bc193c.png";